import api from './api';

export const getSaasPlans = (page, params) => {
  return api.get('admin/SaasPlan', { params: { page: page, limit: 5, ...params } });
};
export const getSaasFeatureLimits = uid => {
  return api.get(`admin/saasFeatureLimits/${uid}`);
};

export const getSaasPlan = uid => {
  return api.get(`admin/saasPlan/${uid}`);
};

export const createSaasPlans = body => {
  return api.post('admin/saasPlans', body);
};

export const updateSaasFeatureLimits = (uid, saasLimit) => {
  return api.put(`admin/saasFeatureLimits/${uid}`, { ...saasLimit });
};

export const updateSaasPlans = (saasId, dataForm) => {
  return api.put(`admin/saasplans/${saasId}`, { dataForm });
};

export const deleteSaasPlans = saasId => {
  return api.delete(`admin/saasPlans/${saasId}`);
};

export const createCheckout = (saasPlanIds, coupons) => {
  return api.get('admin/checkout', { params: { saasPlanIds, coupons } });
};

export const createCouponCourtesy = saasPlanId => {
  return api.post('admin/coupon-courtesy', { saasPlanId });
};
